import { call, select } from 'redux-saga/effects'
import { action as apiAction } from 'api/Api'
import sweetalert from 'sweetalert2'

export default function * requestImportCards (action) {
  const { boardIds, listId, isResponsible } = action.payload

  const state = yield select()

  sweetalert({
    type: 'info',
    text: state.kanbo.locale.messages['MYBOARD_ADD_CARDS_IN_PROGRESS'],
    showConfirmButton: false,
    allowOutsideClick: false
  }).catch(sweetalert.noop)

  const VCards = yield call(apiAction, 'AddCardsToMyBoard', {
    boardIds,
    vListId: listId,
    isResponsible
  })

  const length = VCards.length
  if (length) {
    try {
      yield call(sweetalert, {
        type: 'success',
        text: state.kanbo.locale.messages['MYBOARD_ADD_CARDS_SUCCESS'].replace('{0}', length)
      })
    } catch (e) {}
  } else {
    try {
      yield call(sweetalert, {
        type: 'info',
        text: state.kanbo.locale.messages['MYBOARD_ADD_CARDS_NO_CARDS']
      })
    } catch (e) {}
  }
}
